import mitt from 'mitt';

export const maintenanceEmitter = mitt(); // create and export a global event emitter instance. maintenanceEmitter is used to communicate maintenance mode status throughout the app. This allows different parts of the app to listen for or emit events

// Without this, I would have to manually trigger re-renders or poll more frequently to detect maintenance mode.
// Using an event emitter allows instant response to server status changes across the app.
// Any component or logic can broadcast (maintenanceEmitter.emit('maintenance-on'))
// Any component or logic can listen (maintenanceEmitter.on('maintenance-on', () => setMaintenance(true)))
